import { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, ProgressBar } from 'react-bootstrap'
import tableUserIcon from 'assets/images/roompage-table-user.svg'
import tableCoinIcon from 'assets/images/coin.svg'
import tableStatusIcon from 'assets/images/roompage-table-status.svg'
import Table from 'components/Table'
import { useAtom } from 'jotai'
import {
	roomListAtom,
	roomListFilteredAtom,
	roomSearchAtom,
} from 'config/store'
import JoinModal from 'components/Modal/JoinModal'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { PATHS } from 'config/routes'
import { useQuery } from 'react-query'
import {
	getListRoomOfGameQuery,
	getUserInfoQuery,
	useCreateRoomByPlayNowOfGame,
	useJoinRoomNowOfGame,
} from 'dataLayer/game'
import { getUserQuery, useAcceptInviteFriend } from 'dataLayer/user'
import LoginWebModal from 'components/Modal/LoginWebModal'
import { getUserinfo } from 'utils/localStorage'
import { SocketContext } from 'utils/socket'
import { useDispatch } from 'react-redux'
import { closeSnackbar, showSnackbar } from 'store/actions'

function RoomTable({ randomRoom, level }) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { roomId } = useParams()
	const DOMAIN_UID = process.env.REACT_APP_DOMAIN_UID
	const CLIENTID = process.env.REACT_APP_CLIENTID
	const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI

	const [roomListSearch] = useAtom(roomListFilteredAtom)
	const [roomSearch] = useAtom(roomSearchAtom)

	const [limit, setLimit] = useState(10)
	const [pageIndex, setPageIndex] = useState(0)
	const [roomList, setRoomList] = useState([])
	const { socket, setSocketRoomId } = useContext(SocketContext)
	const [roomSelect, setRoomSelect] = useState({})

	const { data, isLoading } = useQuery(
		getListRoomOfGameQuery(roomId, pageIndex * limit, limit, '', level),
	)
	const { data: userInfo } = useQuery(getUserInfoQuery())

	useEffect(() => {
		if (data) {
			setRoomList(data?.rooms)
		}
	}, [data, level])
	// let roomList = data?.rooms
	let totalCount = data?.total
	const onChangePage = page => {
		setPageIndex(page)
	}
	const onChangePageSize = num_limit => {
		setPageIndex(0)
		setLimit(num_limit)
	}

	const { data: user } = useQuery(getUserQuery())

	const [modalShowLoginPass, setModalShowLoginPass] = useState(false)
	function openLoginModal() {
		// setModalShowLoginPass(true)
		window.location.href = `${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`
	}

	const [modalJoinGame, setModalJoinGame] = useState(false)
	const handleDataJoinGame = useCallback(
		data => {
			if (roomSelect.coin <= userInfo.coin) {
				// setSocketRoomId(roomSelect.id)
				fnJoin({
					room_id: roomSelect.id,
					password: data,
				})
			} else {
				dispatch(showSnackbar(true, t('room.table.check_coin'), 'error'))
				// alert(t('room.table.check_coin'))
			}
		},
		[roomSelect],
	)
	function openJoinModal(data) {
		if (getUserinfo()) {
			setRoomSelect(data)
			if (data.required_password) {
				setModalJoinGame(true)
			} else {
				if (data.coin <= userInfo.coin) {
					// setSocketRoomId(data.id)
					fnJoin({
						room_id: data.id,
					})
				} else {
					dispatch(showSnackbar(true, t('room.table.check_coin'), 'error'))
					// alert(t('room.table.check_coin'))
				}
			}
		} else {
			openLoginModal()
		}
	}
	function closeJoinModal() {
		setModalJoinGame(false)
	}
	const _createRoomByPlayNowSuccess = result => {
		if (result) {
			let data = result.data.playing
			// setSocketRoomId(data.room_id)
			socket.emit('join room', { room_id: data.room_id })
			// navigate(
			// 	PATHS.PLAYROOM_PAGE.replace(':roomId', data.game_id).replace(
			// 		':gameId',
			// 		data.room_id,
			// 	),
			// )
		}
		dispatch(showSnackbar(true, t('modal.success'), 'success'))
	}
	const dispatch = useDispatch()
	const _createRoomByPlayNowError = data => {
		dispatch(showSnackbar(true, data.message || "Can't play now!", 'error'))
	}
	const _joinRoomNowSuccess = result => {
		if (result) {
			let data = result.data.joinRoom
			socket.emit('join room', { room_id: data.room_id })
			// setSocketRoomId(data.room_id)
			// navigate(
			// 	PATHS.PLAYROOM_PAGE.replace(':roomId', data.game_id).replace(
			// 		':gameId',
			// 		data.room_id,
			// 	),
			// )
		}
		dispatch(showSnackbar(true, t('modal.success'), 'success'))
	}
	const _joinRoomNowError = data => {
		dispatch(showSnackbar(true, data.message || "Can't join room!", 'error'))
	}
	const { mutate, data: dataPlay } = useCreateRoomByPlayNowOfGame(
		_createRoomByPlayNowSuccess,
		_createRoomByPlayNowError,
	)
	const { mutate: fnJoin } = useJoinRoomNowOfGame(
		_joinRoomNowSuccess,
		_joinRoomNowError,
	)
	const handlePlayNow = useCallback(() => {
		if (getUserinfo()) {
			mutate({
				game_id: roomId,
				level_id: level,
			})
		} else {
			openLoginModal()
		}
	}, [roomId, level])

	const columns = useMemo(
		() => [
			{
				accessorKey: 'id', //t('room.table.id').toLowerCase(),
				cell: info => info.getValue(),
				header: () => <span>{t('room.table.id')}</span>,
				footer: props => props.column.id,
			},
			{
				accessorFn: row => row.player_count,
				enableColumnFilter: false,
				id: 'player',
				cell: info => {
					return (
						<div className="progress-container">
							<img
								src={tableUserIcon}
								width="20"
								alt="User number in this room"
							/>
							<ProgressBar variant="secondary" now={info.getValue()} max="2" />
							<p>{`${info.getValue()}/2`}</p>
						</div>
					)
				},
				header: () => <span>{t('room.table.player')}</span>,
				footer: props => props.column.id,
			},
			{
				accessorFn: row => row.coin,
				enableColumnFilter: false,
				id: 'coin',
				cell: info => {
					return (
						<div className="betcoin-container">
							<div style={{ display: 'flex', marginLeft: '30%' }}>
								<img src={tableCoinIcon} width="20" alt="Bet's coin" />
								<p style={{ marginLeft: '15%' }}>
									{new Intl.NumberFormat('lo').format(info.getValue())}
								</p>
							</div>
							{/* <img src={tableCoinIcon} width="20" alt="Bet's coin" />
							<p>{new Intl.NumberFormat('lo').format(info.getValue())}</p> */}
						</div>
					)
				},
				header: () => <span>{t('room.table.bet_level')}</span>,
				footer: props => props.column.id,
			},
			{
				accessorFn: row => row.status,
				enableColumnFilter: false,
				id: 'status',
				cell: info =>
					info.getValue() === 2 ? (
						<img
							src={tableStatusIcon}
							width="40"
							className="room-status"
							alt="Room's status"
						/>
					) : null,
				header: () => <span>{t('room.table.status')}</span>,
				footer: props => props.column.id,
			},
			{
				accessorFn: row => row.status,
				enableColumnFilter: false,
				id: 'play now',
				cell: (info, row) => {
					return getUserinfo() ? (
						<Button
							disabled={info.row.original.player_count === 1 ? false : true}
							onClick={() => openJoinModal(info.row.original)}
						>
							{t('room.table.join')}
						</Button>
					) : (
						<Button
							disabled={info.row.original.player_count === 1 ? false : true}
						// onClick={() => openJoinModal(info.row.original)}
						>
							<Link
								style={{
									color: 'white',
									width: '100%',
									display: 'flex',
									justifyContent: 'center',
								}}
								to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
							>
								{t('room.table.join')}
							</Link>
						</Button>
					)
				},
				header: () =>
					getUserinfo() ? (
						<Button className="playnow-header" onClick={handlePlayNow}>
							{t('game_card.play_btn')}
						</Button>
					) : (
						<Button className="playnow-header">
							<Link
								style={{
									color: 'white',
									width: '100%',
									display: 'flex',
									justifyContent: 'center',
								}}
								to={`${DOMAIN_UID}?client_id=${CLIENTID}&redirect_uri=${REDIRECT_URI}&use_callback_uri=true`}
							>
								{t('game_card.play_btn')}
							</Link>
						</Button>
					),
				footer: props => props.column.id,
			},
		],
		[handlePlayNow],
	)
	return (
		<>
			<Table
				{...{
					data: !isLoading
						? roomSearch.length === 0
							? roomList
							: roomListSearch
						: [],
					columns,
					totalCount,
					onChangePage,
					onChangePageSize,
					pageIndex,
				}}
			/>
			{user ? (
				<JoinModal
					show={modalJoinGame}
					onHide={closeJoinModal}
					handleDataJoinGame={handleDataJoinGame}
				/>
			) : // : modalShowLoginPass ? (
				// 	<LoginWebModal
				// 		modalShowLoginPass={modalShowLoginPass}
				// 		setModalShowLoginPass={setModalShowLoginPass}
				// 	/>
				// )
				null}
		</>
	)
}

export default RoomTable
